import React from 'react'
import AccessoryItem from './accessoryItem'

export default function FrequentItem(props) {
    const { availability, price, itemDetails, handleAddedToCart } = props

    return (
        <AccessoryItem
            {...{
                itemDetails,
                availability,
                price,
                handleAddedToCart,
                isParentCalculateStock: true,
                size: 'small',
                type: 'frequentlyPurchasedItem'
            }}
        /> 
    )
}